/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var Channel;

(function (Channel) {
  Channel["SMS"] = "sms";
  Channel["WHATSAPP"] = "whatsapp";
  Channel["WEB_CHAT"] = "web_chat";
  Channel["AI"] = "ai";
})(Channel || (Channel = {}));